import React, { ReactElement } from 'react';
import { useParams } from 'react-router';
import { Link } from 'idsk-react-components';
import UserRole from '../../../../model/currentuser/UserRole';
import routes from '../../../../routing/routes';
import Secured from '../../../Secured';
import sendWithout from '../../icons/notes-off.svg';

const SendBezPripomienokAdminButton = (): ReactElement => {
  // @ts-ignore
  const { type, year, index } = useParams<{ type: string, year: number, index: number }>();

  return (
    <Secured
      allowForRoles={[UserRole.SUPERADMIN]}
    >
      <li key=">Pridať subjekt BP (admin)" className="action-item">
        <div className="icon-wrapper">
          <img src={sendWithout} className="icon" alt="Pridať subjekt bez pripomienok" />
        </div>
        <Link
          to={routes.admin.addSubjektBezPripomienok.withParams(type, year, index)}
          className="button-inline-text send-comments-button"
        >Pridať subjekt BP (admin)
        </Link>
      </li>
    </Secured>
  );
};
export default SendBezPripomienokAdminButton;
